module.exports = __webpack_public_path__ + "img/rnd_pt_fine_bolt.prt.88357f91.jpg";